import { api } from '../../api';

export const alertService = {
  getAlertDetailByType,
};

// Naming of this is confusing - alert data is on the "passive parameter" controller,
// which is why it needs /passive in the URL - this may be refactored at some point
function getAlertDetailByType(patientId: string, type: any) {
  return api.get(`/passive/latest/alerts/${patientId}/${type}`);
}
